import { useContext } from "react";
import { DndProvider, DndContext as ReactDndContext } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

// react-dnd requires exactly one HTML5Backend per tree. Skip nesting if an
// ancestor already provides one (e.g. ChatNoteTab); otherwise mount our own.
// Use this for components that may be rendered both inside and outside an
// existing DnD context (e.g. modals that open from multiple call sites).
export default function ConditionalDndProvider({ children }) {
  const existing = useContext(ReactDndContext);
  if (existing?.dragDropManager) return children;
  return <DndProvider backend={HTML5Backend}>{children}</DndProvider>;
}
